<template>
    <div>
        <a class="forex-bottom-details-show-box" :href="`${signupUrl}&utm_content=bestbroker`"
            target="_blank" rel="nofollow">
            <img class="logo-column" src="../../assets/image/logo/logo_column.svg" alt="" />
            <div class="forex-bottom-details-show-honner-box">
                <img class="forex-bottom-details-show-honner-icon" src="../../assets/image/forex/banner/icon-left.png"
                    alt="" />
                <div class="forex-bottom-details-show-honner-name-box">
                    <p class="forex-honner-honner-name">全球最佳券商</p>
                </div>
                <img class="forex-bottom-details-show-honner-icon" src="../../assets/image/forex/banner/icon-right.png"
                    alt="" />
            </div>
            <img class="forex-bottom-details-show-player-img" src="../../assets/image/forex/banner/player.png" alt="" />
            <div class="forex-bottom-details-show-btn">立即开户</div>
        </a>
        <a class="forex-bottom-details-show-box-mobile"
            :href="`${signupUrl}&utm_content=bestbroker`" target="_blank" rel="nofollow">
            <div class="forex-bottom-details-show-box-mobile-left">
                <div class="forex-bottom-details-show-honner-box">
                    <img class="forex-bottom-details-show-honner-icon"
                        src="../../assets/image/forex/banner/icon-left.png" alt="" />
                    <div class="forex-bottom-details-show-honner-name-box">
                        <p class="forex-honner-honner-name">全球最佳券商</p>
                    </div>
                    <img class="forex-bottom-details-show-honner-icon"
                        src="../../assets/image/forex/banner/icon-right.png" alt="" />
                </div>
                <div class="forex-bottom-details-show-btn">立即开户</div>
            </div>
            <div class="forex-bottom-details-show-box-mobile-right">
                <img class="logo-row" src="../../assets/image/logo/logo_row.svg" alt="" />
                <img class="forex-bottom-details-show-player-img" src="../../assets/image/forex/banner/player.png"
                    alt="" />
            </div>
        </a>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "footer-detail",
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
}

</script>

<style scoped>

.forex-bottom-details-show-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 140rem;
  width: 100%;
  background-image: url("../../assets/image/forex/banner/bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  padding-left: 10rem;
  padding-right: 10rem;
  border-radius: 8rem;
}
.forex-bottom-details-show-box-mobile {
  display: none;
}
.logo-column {
  height: 54rem;
}
.forex-bottom-details-show-honner-box {
  display: flex;
  align-items: center;
}

.forex-bottom-details-show-honner-icon {
  width: 56rem;
}
.en .forex-bottom-details-show-honner-icon {
  width: 38rem;
}
.forex-bottom-details-show-honner-name-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8rem;
  flex-shrink: 0;
}
.forex-honner-honner-name {
  margin-bottom: 0;
  font-size: 42rem;
  font-weight: 700;
  background: linear-gradient(92deg, #c2936a 0.01%, #9f734c 100.01%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
}
.en .forex-honner-honner-name {
  font-size: 24rem;
}

.forex-bottom-details-show-player-img {
  width: 220rem;
  align-self: flex-end;
  flex-shrink: 1;
}

.forex-bottom-details-show-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44rem;
  border-radius: 22rem;
  padding: 0 24rem;
  background: #a52933;
  color: var(--Text-Primary_White, #fff);
  text-align: center;
  font-size: 14rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  animation: forexBtnAnimation 1.5s infinite;
}
@keyframes forexBtnAnimation {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
.forex-bottom-details-show-btn:hover {
  background: #cc333f;
  color: #fff;
}
.forex-bottom-details-show-btn:active {
  background: #7b1e26;
}
@media (max-width: 996px) {
  .forex-bottom-details-show-box {
    display: none;
  }
  .forex-bottom-details-show-box-mobile {
    position: relative;
    display: flex;
    justify-content: space-around;
    min-height: 240rem;
    background-image: url("../../assets/image/forex/banner/bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    padding-left: 10rem;
    padding-right: 10rem;
    border-radius: 16rem;
    gap: 18rem;
  }
  .logo-row {
    height: 31rem;
  }
  .forex-bottom-details-show-box-mobile-left {
    flex-shrink: 0;
    flex-grow: 1;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .forex-honner-honner-name {
    font-size: 38rem;
  }
  .en .forex-honner-honner-name {
    font-size: 28rem;
  }
  .forex-bottom-details-show-honner-icon {
    width: 50rem;
  }
  .en .forex-bottom-details-show-honner-icon {
    width: 46rem;
  }

  .forex-bottom-details-show-box-mobile-right{
    align-self: flex-end;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .forex-bottom-details-show-btn {
    margin-top: 24rem;
    height: 46rem;
    border-radius: 23rem;
    padding: 0 48rem;
    font-size: 20rem;
  }
  .forex-bottom-details-show-player-img {
    margin-top: 12rem;
    width: 290rem;
  }
}

</style>